module.exports = __webpack_public_path__ + "media/images/hello_drifter_lockup1_blk_cropped-0e1e5e34d1ed450ae4628b0daf1fb175.png";